import moment from 'moment'
import * as R from 'ramda'

import { SalesRepsMetricCategories } from 'types/salesRepSetup'
import { trackEvent } from 'utils/tracking'

import {
  GET_HELP_LINK,
  MANAGE_TEAMMATES_LINK,
  MAX_USER_LAST_ACTIVE_TIME,
  USER_HELP_LINK,
} from './constants'

export const getMetrics = (data) => {
  const metrics = {
    teamAssigned: 0,
    nameAdded: 0,
    photoUploaded: 0,
    notificationsEnabled: 0,
    calendarConnected: 0,
    conferenceLinkAdded: 0,
  }

  for (const item of data) {
    metrics.teamAssigned += item.teamIds.length ? 1 : 0
    metrics.nameAdded += item.status.fullName ? 1 : 0
    metrics.photoUploaded += item.status.profilePhoto ? 1 : 0
    metrics.notificationsEnabled += item.status.notificationSettings ? 1 : 0
    metrics.calendarConnected += item.status.connectedCalendar ? 1 : 0
    metrics.conferenceLinkAdded += item.status.conferenceLink ? 1 : 0
  }

  return metrics
}

export const getStatusIndicator = (metric, data) => {
  const percentage = (metric / data.length) * 100
  if (percentage < 50) {
    return 'danger'
  } else if (percentage >= 50 && percentage < 99) {
    return 'warning'
  } else {
    return 'success'
  }
}

export const getIncompleteSalesReps = (metricIdentifier, metrics) => {
  const filters = {
    [SalesRepsMetricCategories.TEAM_ASSIGNED]: (item) => !item.teamIds.length,
    [SalesRepsMetricCategories.NAME_ADDED]: (item) => !item.status.fullName,
    [SalesRepsMetricCategories.PHOTO_UPLOADED]: (item) =>
      !item.status.profilePhoto,
    [SalesRepsMetricCategories.NOTIFICATIONS_ENABLED]: (item) =>
      !item.status.notificationSettings,
    [SalesRepsMetricCategories.CALENDAR_CONNECTED]: (item) =>
      !item.status.connectedCalendar,
    [SalesRepsMetricCategories.CONFERENCE_LINK_ADDED]: (item) =>
      !item.status.conferenceLink,
  }

  const filterFunc = filters[metricIdentifier] || (() => [])
  return metrics.filter(filterFunc)
}

export const getPercentage = (metric, data) =>
  R.isEmpty(data) ? 0 : ((metric / data.length) * 100).toFixed(0)

export const resolveLastActiveDate = (timestamp) => {
  if (!timestamp) {
    return MAX_USER_LAST_ACTIVE_TIME
  }
  if (R.equals('N/A', timestamp)) {
    return timestamp
  }

  const momentTimestamp = moment(new Date(timestamp), 'YYYYMMDD').fromNow()
  if (momentTimestamp.includes('year')) {
    return MAX_USER_LAST_ACTIVE_TIME
  }
  if (
    momentTimestamp.includes('minutes') ||
    momentTimestamp.includes('seconds')
  ) {
    return '< 1 hour ago'
  }
  return momentTimestamp
}

const goToManageTeammates = () => {
  trackEvent('SALES_REP_TEAM_MANAGE_TEAMMATES_LINK_CLICKED')
  window.open(MANAGE_TEAMMATES_LINK, '_blank')
}

export const getActionMenuOptions = (
  metricIdentifier,
  handleCopyEmailToClipboard,
  incompleteSalesRepMetric
) => {
  const options = [
    {
      name: 'Copy emails of incomplete sales reps',
      action: () => handleCopyEmailToClipboard(incompleteSalesRepMetric),
    },
  ]

  switch (metricIdentifier) {
    case SalesRepsMetricCategories.TEAM_ASSIGNED:
      options.push(
        {
          name: 'Go to Manage teammates',
          action: () => goToManageTeammates(),
        },
        {
          name: 'How do I assign teams?',
          action: () => {
            trackEvent('SALES_REP_TEAM_ASSIGN_HELP_LINK_CLICKED')
            window.open(GET_HELP_LINK, '_blank')
          },
        }
      )
      break

    case SalesRepsMetricCategories.NAME_ADDED:
    case SalesRepsMetricCategories.PHOTO_UPLOADED:
      options.push({
        name: 'Go to Manage teammates',
        action: () => goToManageTeammates(),
      })
      break

    case SalesRepsMetricCategories.CALENDAR_CONNECTED:
      options.push({
        name: 'How to connect calendar',
        action: () => {
          trackEvent('SALES_REP_CALENDAR_HELP_LINK_CLICKED')
          window.open(USER_HELP_LINK, '_blank')
        },
      })
      break
  }

  return options
}
